import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionSkills = props => {
  return (
    <Hoc>
      <CvItem title="Language" imgSrc="">
        <CvItemDesc descBold="Persian" descNormal="Native" />
        <CvItemDesc descBold="English" descNormal="Professional Proficiency">
          <CvItemDetail> TOEFL - iBT (29 Jan, 2011): Total&nbsp;Score:&nbsp;98 (R:&nbsp;25&nbsp;L:&nbsp;29&nbsp;S:&nbsp;22&nbsp;W:&nbsp;22) </CvItemDetail>
          <CvItemDetail> IELTS - General Training (10 Feb 2018): Band&nbsp;Score:&nbsp;7.5 (L:&nbsp;7.5&nbsp;R:&nbsp;8.5&nbsp;S:&nbsp;7&nbsp;W:&nbsp;7) </CvItemDetail>
        </CvItemDesc>
        <CvItemDesc descBold="Deutsch" descNormal="Elementray Level (A2) " descComment="Learning..." />
        <CvItemDesc descBold="Dutch" descNormal="Basic Understanding" />
      </CvItem>

      <CvItem title="Software" imgSrc="">
        <CvItemDesc descBold="Architecture" descNormal="">
          <CvItemDetail> Autodesk AutoCAD 2D &amp; 3D </CvItemDetail>
          <CvItemDetail> Autodesk Revit </CvItemDetail>
          <CvItemDetail> Google SketchUp </CvItemDetail>
          <CvItemDetail> Autodesk 3ds Max - Mental Ray &amp; V-ray Render Engines </CvItemDetail>
          <CvItemDetail> Rhinoceros &amp; Grasshopper </CvItemDetail>
        </CvItemDesc>
        <CvItemDesc descBold="Graphics & Web" descNormal="" descComment="">
          <CvItemDetail> Adobe Master Collection (Photoshop, InDesign, Illustrator) </CvItemDetail>
          <CvItemDetail> HTML, CSS , JavaScript, Node.js, React.Js, React.Native</CvItemDetail>
          <CvItemDetail> Adobe Muse, Adobe Flash - Action Scripts </CvItemDetail>
        </CvItemDesc>
        <CvItemDesc descBold="Other" descNormal="">
          <CvItemDetail> Microsoft Office (Word, PowerPoint &amp; Excel) </CvItemDetail>
          <CvItemDetail> Familiar with Arduino, and Digital Fabrication Sotware </CvItemDetail>
        </CvItemDesc>
      </CvItem>

      <CvItem title="Other Skills & Hobbies">
        <CvItemDesc descBold="" descNormal="Graphic Design & Web design, Digital Fabrication, Photography" />
        <CvItemDesc descNormal="Books, Playing the Guitar, Movies and Sports, Painting and Drawing" />
      </CvItem>
    </Hoc>
  );
};

export default cvSectionSkills;
